import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { FestivalLoading } from '../FestivalContext/FestivalLoading'

// Öffentliche Seiten liegen außerhalb von /app; innerhalb der App ist die Location relativ zu /app
export const LeaveApp = () => {
  const { pathname, search, hash } = useLocation()

  useEffect(() => {
    window.location.replace(`${pathname}${search}${hash}`)
  }, [hash, pathname, search])

  return (
    <FestivalLoading />
  )
}
